<template>
  <div class="filters" >
    <portfolio-filter
      name="категории"
      :list_types="maintypes"
      :dispatch="'setCategory'"
      v-on:toggle-show-shadow="toggleShowShadow(...arguments);"
      :top="true"
      :active="activeCategory"
    />
    <portfolio-filter
      name="виды"
      v-if="subcategory_list.length"
      :list_types="subcategory_list"
      :dispatch="'setSubCategory'"
      v-on:toggle-show-shadow="toggleShowShadow(...arguments);"
      :active="activeSubcategory"
    />
    <transition name="fade">
      <div class="portfolio_blue" v-show="isShowShadow"></div>
    </transition>
    <p class="filters__desc">{{ description }}</p>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { filters } from 'src/utils/consts';
import Filter from './Filter';


export default {
  components: {
    'portfolio-filter': Filter,
  },
  data() {
    return {
      filters,
      types_items: [],
      isShowShadow: false,
      activeCategory: '',
      activeSubcategory: '',
    };
  },
  async created() {
    this.fetchPortfolio();
    this.fetchNotEmptyCategory();
    this.activeCategory = this.$store.state.category;
    this.activeSubcategory = this.$store.state.subcategory;
  },
  methods: {
    ...mapActions(['fetchPortfolio', 'fetchNotEmptyCategory']),
    toggleShowShadow(value) {
      this.isShowShadow = value;
    },
  },
  computed: {
    ...mapGetters(['subcategory_list', 'description']),
    maintypes() {
      return this.filters;
    },
    subtypes() {
      const category = this.filters.find(el => el.tp === this.activeCategory);
      return category.types;
    },
  },
};
</script>

<style lang="scss">
@import "~styles/vars.scss";

.filters__desc{
  font-family: "Playfair Display", serif;
  font-size: 16px;
  line-height: 32px;
  letter-spacing: 0.5px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  z-index: 3;
  width: 660px;
  margin: 40px auto 20px;
  @media only screen and (max-width: $phone) {
    margin: get-vw(20px) auto get-vw(5px);
    font-size: get-vw(13px);
    line-height: 1.71;
    width: get-vw(280px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/portfolio/Filters.vue